import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { isNullOrWhiteSpace } from 'ecs-react-components/dist/index.es';
import { messages } from './hormoneTherapy.i18n';
import { SecondaryDisplayItem } from './secondaryDisplayItem';

export class HormoneTherapyDetail extends React.Component {
  configurationActive = (fieldName) => {
    if (this.props.capabilities.details.find((x) => x.fieldName === fieldName)) {
      return true;
    }
    return false;
  }

  render() {
    const agentName = isNullOrWhiteSpace(this.props.hormoneTherapy.agentNameDisplay) ?
      this.props.hormoneTherapy.agentName :
      this.props.hormoneTherapy.agentNameDisplay;
    const route = isNullOrWhiteSpace(this.props.hormoneTherapy.routeDisplay) ?
      this.props.hormoneTherapy.route :
      this.props.hormoneTherapy.routeDisplay;
    const frequency = isNullOrWhiteSpace(this.props.hormoneTherapy.frequencyDisplay) ?
      this.props.hormoneTherapy.frequency :
      this.props.hormoneTherapy.frequencyDisplay;
    const trialIndicator = isNullOrWhiteSpace(this.props.hormoneTherapy.trialIndicatorDisplay) ?
      this.props.hormoneTherapy.trialIndicator :
      this.props.hormoneTherapy.trialIndicatorDisplay;

    return (
      this.props.hormoneTherapy.isNullMessageHolder === false ?
      <div className="row item-row" data-qa={'hormoneTherapy_' + agentName}>
        <div className="col-md-4 primary-data">
          {
            this.props.hormoneTherapy.isPatientReviewed === false ?
              <span className="fa fa-circle"></span> : null
          }
          {agentName}
        </div>
        <div className="col-md-8 secondary-data">
            <div className="inline-list">
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.trialName} />}
                value={this.props.hormoneTherapy.trialName} language={this.props.language}
                isActive={this.configurationActive('TrialName')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.startDate} />}
                value={this.props.hormoneTherapy.startDate} language={this.props.language} isDate
                isActive={this.configurationActive('StartDate')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.mostRecentTreatmentDate} />}
                value={this.props.hormoneTherapy.mostRecentTreatmentDate} language={this.props.language} isDate
                isActive={this.configurationActive('MostRecentTreatmentDate')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.endDate} />}
                value={this.props.hormoneTherapy.endDate} language={this.props.language} isDate
                isActive={this.configurationActive('EndDate')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.doseAmount} />}
                value={this.props.hormoneTherapy.doseAmount} language={this.props.language}
                isActive={this.configurationActive('DoseAmount')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.plannedDuration} />}
                value={this.props.hormoneTherapy.plannedDuration} language={this.props.language}
                isActive={this.configurationActive('PlannedDuration')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.frequency} />}
                value={frequency} language={this.props.language}
                isActive={this.configurationActive('Frequency')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.provider} />}
                value={this.props.hormoneTherapy.provider} language={this.props.language}
                isActive={this.configurationActive('Provider')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.institution} />}
                value={this.props.hormoneTherapy.institution} language={this.props.language}
                isActive={this.configurationActive('Institution')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.providerPhone} />}
                value={this.props.hormoneTherapy.providerPhone} language={this.props.language}
                isActive={this.configurationActive('ProviderPhone')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.providerEmail} />}
                value={this.props.hormoneTherapy.providerEmail} language={this.props.language}
                isActive={this.configurationActive('ProviderEmail')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.dosageForm} />}
                value={this.props.hormoneTherapy.dosageForm} language={this.props.language}
                isActive={this.configurationActive('DosageForm')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.drugCategory} />}
                value={this.props.hormoneTherapy.drugCategory} language={this.props.language}
                isActive={this.configurationActive('DrugCategory')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.route} />}
                value={route} language={this.props.language}
                isActive={this.configurationActive('Route')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.trialIndicator} />}
                value={trialIndicator} language={this.props.language}
                isActive={this.configurationActive('TrialIndicator')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.comment} />}
                value={this.props.hormoneTherapy.comment} language={this.props.language}
                isActive={this.configurationActive('Comment')}
              />
            </div>
        </div>
      </div>
        :
      <div className="row item-row" data-qa="hormoneTherapy_nullMessage">
        <div className="col-md-4 primary-data">
          {this.props.hormoneTherapy.nullMessage}
        </div>
      </div>
    );
  }
}

HormoneTherapyDetail.propTypes = {
  hormoneTherapy: PropTypes.object.isRequired,
  language: PropTypes.string,
  capabilities: PropTypes.object.isRequired,
};
